import React from "react";
import { Button, Col, Input, Row, Select } from "antd";
import style from "./index.module.scss";
import { searchItem } from "../../index";
import Form from "rc-field-form";
import { useAtomValue } from "jotai";
import { termListAtom } from "service/stores/CommonStore";
import {
    CurrentTermType,
    getCourseListByTeacher,
    QueTypeId
} from "service/answerStore";
import classNames from "classnames";
import useRequest from "utils/useRequest";
import { useAtom } from "jotai";
import { batchNosAtom } from "pages/answerStore/store";
import FieldWithErrorHaveLabel from "../../../../../components/FieldWithErrorHaveLabel";

interface TopOperationsProps {
    onFinish: (val: searchItem) => void;
}

const fieldProps: any = {
    align: "middle",
    span: [7, 17]
};

export default function TopOperations({ onFinish }: TopOperationsProps) {
    const { Option } = Select;
    const [form] = Form.useForm<searchItem>();

    const batchList = useAtomValue(termListAtom);
    const [batchNo, setBatchNo] = useAtom(batchNosAtom);
    const [courseList, { loading }] = useRequest(
        () => getCourseListByTeacher(batchNo),
        {},
        [batchNo]
    );

    return (
        <Form form={form} onFinish={onFinish} className={style.root}>
            <Row gutter={30}>
                <Col span={6}>
                    <FieldWithErrorHaveLabel
                        {...fieldProps}
                        label="选择学期："
                        name="batchNo"
                        initialValue={[]}>
                        <Select
                            mode="multiple"
                            allowClear
                            placeholder="请选择学期"
                            maxTagCount={1}
                            onChange={(val: string[]) => setBatchNo([...val])}>
                            {batchList.map(item => (
                                <Option
                                    className={classNames({
                                        [style.option]:
                                            item.isCurrentTerm ===
                                            CurrentTermType.isCurrent
                                    })}
                                    value={item.batchNo}
                                    key={item.batchNo}>
                                    {item.batchName}
                                </Option>
                            ))}
                        </Select>
                    </FieldWithErrorHaveLabel>
                </Col>

                <Col span={6}>
                    <FieldWithErrorHaveLabel
                        {...fieldProps}
                        label="选择课程："
                        name="courseNo"
                        initialValue={[]}>
                        <Select
                            loading={loading}
                            mode="multiple"
                            allowClear
                            placeholder="请选择课程"
                            maxTagCount={1}>
                            {courseList &&
                                courseList.map(item => (
                                    <Option
                                        value={item.courseNo}
                                        key={`${item.courseNo}-${item.courseSeq}-${item.courseName}`}>
                                        [{item.courseNo}] {item.courseName}
                                    </Option>
                                ))}
                        </Select>
                    </FieldWithErrorHaveLabel>
                </Col>

                <Col span={6}>
                    <FieldWithErrorHaveLabel
                        {...fieldProps}
                        label="试题信息："
                        name="search"
                        initialValue="">
                        <Input
                            maxLength={200}
                            placeholder="输入题目关键词查询"
                        />
                    </FieldWithErrorHaveLabel>
                </Col>

                <Col span={6}>
                    <FieldWithErrorHaveLabel
                        {...fieldProps}
                        label="选择题型："
                        name="queTypeId">
                        <Select
                            mode="multiple"
                            allowClear
                            placeholder="请选择题型">
                            <Option value={QueTypeId.Radio}>单选</Option>
                            <Option value={QueTypeId.Checkbox}>多选</Option>
                            <Option value={QueTypeId.Judgment}>判断</Option>
                            <Option value={QueTypeId.Fill}>填空</Option>
                        </Select>
                    </FieldWithErrorHaveLabel>
                </Col>

                <Col span={6}>
                    <FieldWithErrorHaveLabel
                        {...fieldProps}
                        label="选择分类："
                        name="paperType">
                        <Select
                            mode="multiple"
                            allowClear
                            placeholder="请选择分类">
                            <Option value="0">练习</Option>
                            <Option value="1">作业</Option>
                            <Option value="2">考试</Option>
                            <Option value="3">题库</Option>
                        </Select>
                    </FieldWithErrorHaveLabel>
                </Col>

                <Col
                    span={6}
                    offset={12}
                    style={{ textAlign: "right", paddingRight: 15 }}>
                    <Button type="primary" icon="search" onClick={form.submit}>
                        查询
                    </Button>
                    &nbsp;
                    <Button icon="redo" onClick={() => form.resetFields()}>
                        重置
                    </Button>
                </Col>
            </Row>
        </Form>
    );
}
